<template>
  <component :is="component"
             v-bind="$attrs"
             v-on="$listeners"></component>
</template>

<script>
import AsyncLoading from './AsyncLoading'
import AsyncLoadErr from './AsyncLoadErr'
export default {
  name: 'AsyncComponentLoad',
  props: {
    componentPath: {
      type: String,
      required: true
    },
    showLoad: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      component: () => ({
        component: import(`../../${this.componentPath}`).then(c => {
          this.handle('ready')
          return c
        }, err => {
          this.handle('error')
          return Promise.reject(err)
        }),
        loading: this.showLoad ? AsyncLoading : null,
        error: this.showLoad ? AsyncLoadErr : null,
        delay: 200,
        timeout: 10000
      })
    }
  },
  methods: {
    handle (state) {
      this.$emit(state)
    }
  }
}
</script>
